import * as React from 'react'
import { ProgressProp } from './interface'
import { Filler, ProgressBar } from './style'

const Progress: React.FC<ProgressProp> = ({ percent = 0, size, color, className }) => (
  <ProgressBar size={size} className={className}>
    <Filler color={color} style={{ width: `${percent}%` }} />
  </ProgressBar>
)

export default Progress
